<template>
  <div class="h-100 d-flex align-center  justify-center">
    <span class="d-flex align-center text-medium-emphasis">
      &copy;
      {{ new Date().getFullYear() }}
      JKT Gateway. All Rights Reserved
      <!--
        <VIcon
        icon="tabler-heart-filled"
        color="error"
        size="1.25rem"
        class="mx-1"
        /> 
      -->
  
    </span>
  </div>
</template>
